export class Attachment {
    attachmentId?:number;
    attachmentEntityType?:String;
    attachmentMode?:String;
    attachmentTitle?:String;
    attachmentGridId?:number;
    attachLink?:String;
    fkEntityId?:number;
    meetingId?:number;
    attachmentStream?:File; 
    orgCode?:any;
    userId?:any;
    attachmentLink?:String;
    attachmentContentType?:String;
    attachmentContentLength?:number;
    
  }
  export interface PaginationAttachmentResponse {
    dataList: Attachment[];
    totalCount: number;
}
export class FileDetails{
  name!: string;
  progress!: number;
}
